import { render, staticRenderFns } from "./UniversityBadges.vue?vue&type=template&id=254cb714&scoped=true&"
import script from "./UniversityBadges.vue?vue&type=script&lang=js&"
export * from "./UniversityBadges.vue?vue&type=script&lang=js&"
import style0 from "./UniversityBadges.vue?vue&type=style&index=0&id=254cb714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254cb714",
  null
  
)

export default component.exports